


export function generateId(): string {
  
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID();
  }

  
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}


export function getCookie(name: string): string | null {
  if (typeof document === 'undefined') return null;

  const cookies = document.cookie.split(';');
  for (const cookie of cookies) {
    const [key, value] = cookie.trim().split('=');
    if (key === name) {
      return decodeURIComponent(value);
    }
  }
  return null;
}


export function setCookie(name: string, value: string, days: number): void {
  if (typeof document === 'undefined') return;

  const expires = new Date();
  expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);

  
  let cookieStr = `${name}=${encodeURIComponent(value)}`;
  cookieStr += `; expires=${expires.toUTCString()}`;
  cookieStr += '; path=/';

  
  const domain = getParentDomain();
  if (domain) {
    cookieStr += `; domain=${domain}`;
  }

  
  cookieStr += '; SameSite=Lax';
  if (window.location.protocol === 'https:') {
    cookieStr += '; Secure';
  }

  document.cookie = cookieStr;
}


export function deleteCookie(name: string): void {
  setCookie(name, '', -1);
}


function getParentDomain(): string | null {
  if (typeof window === 'undefined') return null;

  const hostname = window.location.hostname;

  
  if (hostname === 'localhost' || /^\d+\.\d+\.\d+\.\d+$/.test(hostname)) {
    return null;
  }

  
  const parts = hostname.split('.');
  if (parts.length > 2) {
    return '.' + parts.slice(-2).join('.');
  }

  return null;
}


export function getLocalStorage(key: string): string | null {
  try {
    if (typeof localStorage !== 'undefined') {
      return localStorage.getItem(key);
    }
  } catch {
    
  }
  return null;
}


export function setLocalStorage(key: string, value: string): boolean {
  try {
    if (typeof localStorage !== 'undefined') {
      localStorage.setItem(key, value);
      return true;
    }
  } catch {
    
  }
  return false;
}


export function removeLocalStorage(key: string): void {
  try {
    if (typeof localStorage !== 'undefined') {
      localStorage.removeItem(key);
    }
  } catch {
    
  }
}
